export class SearchPostQuery {
  public request: SearchPostQueryRequest;

  constructor(opt?: Partial<SearchPostQuery>) {
    Object.assign(this, opt);
  }
}

export class SearchPostQueryRequest {
  Querytext: string;
  RowLimit?: number;
  EnableSorting?: boolean;
  TrimDuplicates?: boolean;
  SortList?: [{ [key: string]: any; }];
  SelectProperties?: Array<string>;
  Properties?: any;

  constructor(opt?: Partial<SearchPostQueryRequest>) {
    Object.assign(this, opt);
  }
}
